if (!customElements.get('delivery-times')) {
  customElements.define(
    'delivery-times',
    class DeliveryTimes extends HTMLElement {
      constructor(){
        super();
        this.updateDates();
        if(this.closest('details')){
          this.closest('details').addEventListener(() => {
            this.updateDates()
          }).bind(this)
        }
      }

      updateDates(){
        var compare_date = new Date()
        var w_d = 0, standard_min_date, standard_max_date, express_min_date, express_max_date
        const working_days = this.dataset.workingDays.split(",").map(elem=> parseInt(elem, 10));
        const holidays = [];
        this.querySelectorAll('holiday-date').forEach( (element) => {
          holidays.push(new Date(element.innerText))
        })

        if(compare_date.getHours() < this.cutoff){w_d += 1;}
        dayLoop: for(var i=0; i<100; i++){
          compare_date.setDate(compare_date.getDate()+1);
          for(var h=0; h<holidays.length; h++){
            if(holidays[h].getDate() == compare_date.getDate() && holidays[h].getMonth() == compare_date.getMonth() && holidays[h].getYear() == compare_date.getYear()) {
              continue dayLoop;
            }
          }
          if(working_days.includes(parseInt(compare_date.getDay()))) {w_d += 1;} else {continue dayLoop;}
          
          if(w_d == this.standardMin) {standard_min_date = new Date(compare_date)}
          if(w_d == this.expressMin) {express_min_date = new Date(compare_date)}
          if(w_d == this.expressMax) {express_max_date = new Date(compare_date)}
          if(w_d == this.standardMax){
            {standard_max_date = new Date(compare_date)}
            break
          }
        }          
        
        this.querySelectorAll('delivery-message.standard-production').forEach((element) => {
          element.querySelector('span[data-type="min"]').innerText = this.formatDate(standard_min_date)
          element.querySelector('span[data-type="max"]').innerText = this.formatDate(standard_max_date)
        })
        this.querySelectorAll('delivery-message.express-production').forEach((element) => {
          if (element.querySelector('span[data-type="min"]')) element.querySelector('span[data-type="min"]').innerText = this.formatDate(express_min_date)
          if (element.querySelector('span[data-type="max"]')) element.querySelector('span[data-type="max"]').innerText = this.formatDate(express_max_date)
        })
      }

      formatDate(date){
        return date.toLocaleDateString(this.locale, {
          weekday: 'long',
          day: 'numeric',
          month: 'long'
        })
      }

      get locale () {
        const locale = this.dataset.locale || document.documentElement.lang || 'en-GB'
        return locale === 'en' ? 'en-GB' : locale
      }

      get standardMin () {
        return parseInt(this.dataset.standardDaysMin)
      }

      get standardMax () {
        return parseInt(this.dataset.standardDaysMax)
      }

      get expressMin () {
        return parseInt(this.dataset.expressDaysMin)
      }

      get expressMax () {
        return parseInt(this.dataset.expressDaysMax)
      }

      get cutoff () {
        return parseInt(this.dataset.cutoffTime)
      }
    }
  )
}